<template>
    <div class="bg-white shadow p-24 rounded border trans-ease border-white">
        <h2 class="font-semibold text-body mb-4 first-letter:uppercase">
            {{ $t('campaigns.editor.steps.details') }}
        </h2>
        <div class="flex justify-between items-center border-b-2 border-primary-5 py-16">
            <p class="first-letter:uppercase font-semibold text-black">{{ $t('applications.job')}}</p>
            <p class="font-semibold text-right">
                {{ campaign.job_title }}
            </p>
        </div>
        <div class="flex justify-between items-center border-b-2 border-primary-5 py-16">
            <p class="first-letter:uppercase font-semibold text-black">
                {{ $t('general.start_date') }}
            </p>
            <p class="font-semibold text-right">
                {{ campaign.date_start }}
            </p>
        </div>
        <div class="flex justify-between items-center border-b-2 border-primary-5 py-16">
            <p class="first-letter:uppercase font-semibold text-black">{{ $t('general.end_date') }}</p>
            <p class="font-semibold text-right">
                {{ campaign.date_end }}
            </p>
        </div>
        <div class="flex justify-between items-center border-b-2 border-primary-5 py-16">
            <p class="first-letter:uppercase font-semibold text-black">{{ $t('campaigns.reference_id') }}</p>
            <p class="font-semibold text-right">
                #{{ campaign.id }}
            </p>
        </div>
        <div class="flex justify-between items-center pt-16">
            <p class="first-letter:uppercase font-semibold text-black">{{ $t('jobs.apply_url') }}</p>
            <p class="font-semibold text-right">
                <a :href="campaign.job_url" target="_blank" class="no-underline text-secondary">
                    {{ link }}
                    <svg-icon type="link" class="h-16 w-16 inline"/>
                </a>
            </p>
        </div>
    </div>
</template>

<script>
import SvgIcon from './ui/SvgIcon';
import Campaign from "../models/Campaign";

export default {
    components: {SvgIcon},
    props: {
        campaign: Campaign
    },
    computed: {
        link() {
            const url = this.campaign.job_url;
            if (url.length < 50)
                return url;

            return `${url.substring(0, 50)}...`
        }
    }
}
</script>
